export default __webpack_public_path__ + "static/media/Jessie 9781408315897.af17a9bf.jpg";